import React, { useEffect } from "react";
import StateDropDown from "../../components/admin/StateDropDown";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  resetBreadcrum,
  updateBreadcrum,
} from "../../redux/reducers/BreadcrumbSlice";
import { useDispatch } from "react-redux";
import { PAGE } from "../../constants/page";
import TabComponent from "../../components/TabComponent";
import { useAppSelector } from "src/redux/hooks";
import { UserState } from "src/redux/reducers/UserSlice";
import Utility from "src/utility/Utility";
import { ROLE } from "src/constants/role";
import { selectedStatePractioner } from "../../redux/reducers/PractionerRoleIdsSlice";
import {  updatedAsha } from "src/redux/reducers/AuthAshaDetailsSlice";

function GlobalAdmin() {
  const dispatch = useDispatch();
  const stateListRedux = useAppSelector(selectedStatePractioner);
  const adminList = [
    {
      adminRoute: "admin",
      title: "Admins",
      translationKey: "admin",
    },
    {
      adminRoute: "asha",
      title: "ASHA",
      translationKey: "asha",
    },
    {
      adminRoute: "patient",
      title: "Patients",
      translationKey: "patients",
    },
  ];

  const navigate = useNavigate();
  const { state } = useParams();
  const location = useLocation();
  const url: string = PAGE.GLOBAL_STATE_ADMIN.replace(":state", state || "");
  const activeTabValue: string = location.pathname.split("/").pop() || "";
  const userDetails: any = useAppSelector(UserState);
  const userRole = Utility.getUserRole(
    userDetails?.userDetails?.app_metadata?.organizations?.EODB?.groups[0]
  );

  const handleBrowserBackButton = async (e: any) => {
    // to avoid back when on home page
    dispatch(updatedAsha({ updated: false }));
    e.preventDefault();
    navigate(`${url}/admin`);
  };

  useEffect(() => {
    window.addEventListener("popstate", handleBrowserBackButton);
    return () => {
      window.removeEventListener("popstate", handleBrowserBackButton);
    };
  }, []);

  useEffect(() => {
    dispatch(resetBreadcrum());
    dispatch(
      updateBreadcrum({
        routeHistory: [
          {
            label: state,
            label_key: "",
            path: `${url}/admin`,
            id: "global_admin",
            value: "",
          },
        ],
        display: false,
      })
    );
  }, [state]);

  const handleTabChange = (userType: string) => {
    navigate(`${url}/${userType}`);
  };

  return (
    <div>
      <StateDropDown
        title={state || ""}
        activeTabValue={activeTabValue}
        showViewReportButton={userRole !== ROLE.GLOBAL_ADMIN_SUPPORT}
        stateListRedux={stateListRedux}
      />
      <TabComponent
        tabList={adminList}
        handleTabChange={handleTabChange}
        activeValue={activeTabValue}
      />
      <Outlet />
    </div>
  );
}

export default GlobalAdmin;
